var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 17.3307C4.39685 17.3307 0.666016 13.5999 0.666016 8.9974C0.666016 4.3949 4.39685 0.664062 8.99935 0.664062C13.6018 0.664062 17.3327 4.3949 17.3327 8.9974C17.3327 13.5999 13.6018 17.3307 8.99935 17.3307ZM8.99935 15.6641C10.7675 15.6641 12.4632 14.9617 13.7134 13.7114C14.9636 12.4612 15.666 10.7655 15.666 8.9974C15.666 7.22929 14.9636 5.53359 13.7134 4.28335C12.4632 3.03311 10.7675 2.33073 8.99935 2.33073C7.23124 2.33073 5.53555 3.03311 4.2853 4.28335C3.03506 5.53359 2.33268 7.22929 2.33268 8.9974C2.33268 10.7655 3.03506 12.4612 4.2853 13.7114C5.53555 14.9617 7.23124 15.6641 8.99935 15.6641ZM8.16602 4.83073H9.83268V6.4974H8.16602V4.83073ZM8.16602 8.16406H9.83268V13.1641H8.16602V8.16406Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f2fb9efb479735f08e6a903dc40fe995.svg";
export { ForwardRef as ReactComponent };